import {AbstractModel, DateConverter, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ResponcePage} from 'projects/core/src/lib/misc/data/responce-page';
import {ShortObject} from '../../project-misc/data/project/short-json-object';
import {ShortProject} from '../../project-misc/data/project/short-project';
import {SaleStat} from './sale-stat';


@JsonObject('ReportStatColumnCounter')
export class ReportStatColumnCounter extends AbstractModel {
  @JsonProperty(String, 'columnName')
  columnName: string;

  @JsonProperty(Number, 'projectsCount')
  projectsCount: number;
}

@JsonObject('ReportStatLine')
export class ReportStatLine extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(DateConverter, 'created')
  created: Date;

  @JsonProperty(ShortObject, 'list')
  list: ShortObject;

  @JsonProperty(ShortObject, 'manager')
  manager: ShortObject;

  @JsonProperty(ShortProject, 'project')
  project: ShortProject;

  @JsonProperty(ShortObject, 'paymentStatus')
  paymentStatus: ShortObject;

  @JsonProperty(ShortObject, 'installationPaymentStatus')
  installationPaymentStatus: ShortObject;
}

@JsonObject('ReportStatsPage')
export class ReportStatsPage extends ResponcePage {

  @JsonProperty([ReportStatLine], 'content')
  content: ReportStatLine[];
}

@JsonObject('ProjectReportStats')
export class ProjectReportStats extends AbstractModel {
  @JsonProperty([ReportStatColumnCounter], 'counters')
  counters?: ReportStatColumnCounter[];

  @JsonProperty(ReportStatsPage, 'projects')
  projects?: ReportStatsPage;

  @JsonProperty(SaleStat, 'salesStats')
  salesStats?: SaleStat;
}

